import { tKey, type I18nKey } from "@/core/i18n";
import { useEffect, useState } from "react";

/** `error` is a catalog key, so the message follows the language. */
export const useImageLoader = (url: string | undefined) => {
  const [image, setImage] = useState<HTMLImageElement | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<I18nKey<"label"> | null>(null);

  useEffect(() => {
    if (!url) {
      setImage(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const img = new window.Image();
    img.onload = () => {
      if (!cancelled) {
        setImage(img);
        setLoading(false);
      }
    };
    img.onerror = () => {
      if (!cancelled) {
        setError(tKey("label:canvas.imageLoadFailed"));
        setLoading(false);
      }
    };
    img.src = url;

    return () => {
      cancelled = true;
    };
  }, [url]);

  return { image, loading, error };
};
